import { render, staticRenderFns } from "./CustomersABC.vue?vue&type=template&id=0844898b&"
import script from "./CustomersABC.vue?vue&type=script&lang=js&"
export * from "./CustomersABC.vue?vue&type=script&lang=js&"
import style0 from "./CustomersABC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports